document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-team-members]').forEach(section => {
    const cards = section.querySelectorAll('[data-member-index]');
    const modal = section.querySelector('[data-modal]');
    const overlay = modal.querySelector('[data-close]');
    const closeBtn = modal.querySelector('.team-member-modal__close');
    const carouselContainer = modal.querySelector('[data-carousel]');
    const prevBtn = modal.querySelector('[data-flickity-prev]');
    const nextBtn = modal.querySelector('[data-flickity-next]');
    let flickityInstance = null;

    // Store handlers for custom navigation
    function handlePrev() {
      if (flickityInstance) flickityInstance.previous();
    }

    function handleNext() {
      if (flickityInstance) flickityInstance.next();
    }

    function openModal(index) {
      // Set up slides
      const slidesHTML = Array.from(cards).map(el => `
        <div class="team-member-modal__slide">
          <div class="team-member-modal__slide-container">
            <div class="team-member-modal__image-container">
              <div class="team-member-modal__image">
                <img src="${el.dataset.picture}" alt="${el.dataset.name}">
              </div>
            </div>

            <div class="team-member-modal__text-container">
              <div class="team-member-modal__name-job-title typeset2 rte">
                <h2 class="team-member-modal__name h4"><strong>${el.dataset.name}</strong></h2>
                <p class="team-member-modal__job-title">${el.dataset.jobTitle || ''}</p>
              </div>

              <div class="typeset2 rte">
                ${el.dataset.bio || ''}
              </div>
            </div>
          </div>
        </div>
      `).join('');

      carouselContainer.innerHTML = slidesHTML;
      modal.style.display = "block";
      document.body.classList.add('no-scroll');

      // Initialize Flickity, but disable transitions for now
      flickityInstance = new Flickity(carouselContainer, {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: false, // Disable drag to avoid accidental movement
        autoPlay: false, // Disable autoplay to avoid sliding
        fade: true
      });

      // Immediately go to the selected index without animation
      flickityInstance.select(index, false, true);

      // Re-enable transitions after a small delay (to let things load)
      setTimeout(() => {
        flickityInstance.options.draggable = true; // Enable dragging
        flickityInstance.options.autoPlay = true; // Enable autoplay if you want it
        flickityInstance.reloadCells(); // Apply changes
      }, 10); // Short delay to ensure modal is visible

      // Add one-time listeners for custom prev/next buttons
      prevBtn.addEventListener('click', handlePrev);
      nextBtn.addEventListener('click', handleNext);
    }

    function closeModal() {
      modal.style.display = "none";
      document.body.classList.remove('no-scroll');

      if (flickityInstance) {
        flickityInstance.destroy();
        flickityInstance = null;
      }

      carouselContainer.innerHTML = '';

      // Clean up event listeners to prevent multiple bindings
      prevBtn.removeEventListener('click', handlePrev);
      nextBtn.removeEventListener('click', handleNext);
    }

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });

    cards.forEach((card, index) => {
      card.addEventListener('click', () => openModal(index));
    });
  });
});
